import React, { useState } from "react";
import ReportViewer from "./ReportViewerComponent";
import { Checkbox, InputPrefix } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Button } from "@progress/kendo-react-buttons";
import { Label } from "@progress/kendo-react-labels";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import Icon from "components/Global/icon";
import styles from "./Reports.module.scss";
import { useEffect } from "react";
import { SectionDividerFull } from "components/Contact/sectionDivider";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { ReportURL } from "api/axios.config";
import { getChartOfAccountBalance } from "api";
import { formatDateForAPI } from "components/common/formatter";
import { BsGraphUpArrow } from "react-icons/bs";
import { PiBank } from "react-icons/pi";
import { HiOutlineChartPie } from "react-icons/hi";
import { useCompany } from "services/companyService";


const NominalBalances = () => {

    const typesData = [
        {
            label: "Trial Balance",
            value: "",
        },
        {
            label: "Balance Sheet",
            value: "BalanceSheet",
        },
        {
            label: "Profit and Loss",
            value: "ProfitAndLoss",
        },
    ];

    let date = new Date();
    const [fromDate, setFromDate] = React.useState(new Date(date.getFullYear(), date.getMonth(), 1));

    const analyzeParameters = () => {

        const params = {
            Type: type,
            ExcludeZero: excludeZero,
            FromDate: includeFromDate ? formatDateForAPI(fromDate) : undefined,
            ToDate: includeEndDate ? formatDateForAPI(endDate) : undefined,
        };

        if (type === "") {
            if (selectedBalanceSheetAccount) {
                params.ChartOfAccountIdBS = selectedBalanceSheetAccount.chartOfAccountId;
            }
            if (selectedProfitAndLossAccount) {
                params.ChartOfAccountIdPL = selectedProfitAndLossAccount.chartOfAccountId;
            }
        }
        else if (type === "BalanceSheet") {

            if (selectedBalanceSheetAccount) {
                params.ChartOfAccountIdBS = selectedBalanceSheetAccount.chartOfAccountId;
            }

            params.ChartOfAccountIdPL = null;

        }
        else if (type === "ProfitAndLoss") {

            if (selectedProfitAndLossAccount) {
                params.ChartOfAccountIdPL = selectedProfitAndLossAccount.chartOfAccountId;
            }

            params.ChartOfAccountIdBS = null;
        }

        if (selectedBalanceSheetAccount || selectedProfitAndLossAccount) {
            params.ExcludeSundry = excludeSundry;
        }

        setParameters(params);
        setShouldLoad(true);
    };

    const [type, setType] = useState("");

    const [includeFromDate, setIncludeFromDate] = useState(false);
    const [includeEndDate, setIncludeEndDate] = useState(false);
    const [selectedPreset, setSelectedPreset] = useState(null);
    const { data: company } = useCompany();

    const presets = [
        { label: "This Month", value: "ThisMonth" },
        { label: "This Quarter", value: "ThisQuarter" },
        { label: "This Year", value: "ThisYear" },
    ];

    const applyPreset = (preset) => {
        const today = new Date();
        let newFromDate, newToDate;
        if (preset === "ThisMonth") {
            newFromDate = new Date(today.getFullYear(), today.getMonth(), 1);
            newToDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        } else if (preset === "ThisQuarter") {
            const startMonth = today.getMonth() - (today.getMonth() % 3);
            newFromDate = new Date(today.getFullYear(), startMonth, 1);
            newToDate = new Date(today.getFullYear(), startMonth + 3, 0);
        } else if (preset === "ThisYear") {
            if (company?.yearStartDate) newFromDate = new Date(company.yearStartDate);
            if (company?.yearEndDate) newToDate = new Date(company.yearEndDate);
        }
        setFromDate(newFromDate);
        setEndDate(newToDate);
        setIncludeFromDate(true);
        setIncludeEndDate(true);
        setSelectedPreset(preset);
    };
    const [excludeZero, setExcludeZero] = useState(true);
    const [excludeSundry, setExcludeSundry] = useState(false);
    const [includeBudgets, setIncludeBudgets] = useState(false);
    const [shouldLoad, setShouldLoad] = useState(false);
    const [balanceSheetAccounts, setBalanceSheetAccounts] = useState([]);
    const [profitAndLossAccounts, setProfitAndLossAccounts] = useState([]);
    const [selectedBalanceSheetAccount, setSelectedBalanceSheetAccount] =
        useState(null);
    const [selectedProfitAndLossAccount, setSelectedProfitAndLossAccount] =
        useState(null);

    const fetchChartOfAccounts = async (type, setState) => {
        try {
            const response = await getChartOfAccountBalance(type);
            setState(response.data.data || []);
        } catch (error) {
            console.error(`Error fetching ${type} accounts:`, error);
        }
    };

    const [endDate, setEndDate] = React.useState(date);
    const [parameters, setParameters] = useState({
        Type: type,
        ExcludeZero: excludeZero,
        FromDate: undefined,
        ToDate: undefined,
    });

    useEffect(() => {
        fetchChartOfAccounts("BalanceSheet", setBalanceSheetAccounts);
        fetchChartOfAccounts("ProfitAndLoss", setProfitAndLossAccounts);
    }, []);

    const hasChartOfAccountSelected = !!(selectedBalanceSheetAccount || selectedProfitAndLossAccount);

    const UpdateButton = (
        <Button className="common-btn w-100" onClick={analyzeParameters}>
            Update
        </Button>
    );

    const dateRangeSection = (
        <div>
            <p className={`${styles.heading} mb-2`} style={{ fontSize: "13px" }}>Date Range</p>
            <div className={styles.dateRangeCards}>
                <div className={styles.dateCard}>
                    <Checkbox
                        value={includeFromDate}
                        onChange={(e) => {
                            setIncludeFromDate(e.value);
                            if (!e.value) setSelectedPreset(null);
                        }}
                        label=""
                    />
                    <div className="ms-1">
                        <span className={styles.dateCardLabel}>From</span>
                        <DatePicker
                            value={fromDate || null}
                            format="dd/MM/yyyy"
                            onChange={(e) => {
                                setFromDate(e.value);
                                setIncludeFromDate(true);
                                setSelectedPreset(null);
                            }}
                            toggleButton={CalenderCustomToggleButton}
                            className={styles.dateCardPicker}
                            width="100%"
                        />
                    </div>
                </div>
                <div className={styles.dateCard}>
                    <Checkbox
                        value={includeEndDate}
                        onChange={(e) => {
                            setIncludeEndDate(e.value);
                            if (!e.value) setSelectedPreset(null);
                        }}
                        label=""
                    />
                    <div className="ms-1">
                        <span className={styles.dateCardLabel}>To</span>
                        <DatePicker
                            value={endDate || null}
                            format="dd/MM/yyyy"
                            onChange={(e) => {
                                setEndDate(e.value);
                                setIncludeEndDate(true);
                                setSelectedPreset(null);
                            }}
                            toggleButton={CalenderCustomToggleButton}
                            className={styles.dateCardPicker}
                            width="100%"
                        />
                    </div>
                </div>
            </div>
            <div className={styles.datePresets}>
                {presets.map((p) => (
                    <button
                        key={p.value}
                        className={`${styles.presetBtn} ${selectedPreset === p.value ? styles.presetBtnActive : ""}`}
                        onClick={() => applyPreset(p.value)}
                    >
                        {p.label}
                    </button>
                ))}
            </div>
        </div>
    );

    const typeIcons = {
        "": <BsGraphUpArrow size={12} />,
        BalanceSheet: <PiBank />,
        ProfitAndLoss: <HiOutlineChartPie />,
    };

    const radioGroup = (
        <div className={styles.typeTabs}>
            {typesData.map((item) => (
                <button
                    key={item.value}
                    className={`${styles.typeTab} ${type === item.value ? styles.typeTabActive : ""}`}
                    onClick={() => {
                        setSelectedBalanceSheetAccount(null);
                        setSelectedProfitAndLossAccount(null);
                        setExcludeSundry(false);
                        setType(item.value);
                    }}
                >
                    <span>{typeIcons[item.value]}</span>
                    <span className="fw-semibold text-nowrap lh-sm" style={{ fontSize: "10.5px" }}>{item.label}</span>
                </button>
            ))}
        </div>
    );

    const IncludeCheckbox = (
        <Checkbox
            // defaultChecked={false}
            value={excludeZero}
            onChange={(e) => {
                setExcludeZero(e.value);
            }}
            label={"Exclude Zero Balances"}
        />
    );

    const ExcludeSundryCheckbox = (
        <Checkbox
            value={excludeSundry}
            onChange={(e) => {
                setExcludeSundry(e.value);
            }}
            label={"Exclude Sundry"}
        />
    );

    const IncludeBudgetsCheckbox = (
        <Checkbox
            value={includeBudgets}
            onChange={(e) => setIncludeBudgets(e.value)}
            label={"Include Budgets"}
        />
    );

    const reportViewer = (
        <ReportViewer
            name={
                includeBudgets
                    ? "NominalBudget.trdp"
                    : selectedBalanceSheetAccount || selectedProfitAndLossAccount
                        ? "ChartOfAccounts.trdp"
                        : "NominalBalances.trdp"
            }
            parameters={parameters}
            shouldLoad={shouldLoad}
            setShouldLoad={setShouldLoad}
            url={`${ReportURL}/Reporting/reports`}
        />
    );

    const balanceSheetComboBox = (
        <ComboBox
            data={balanceSheetAccounts}
            dataItemKey="chartOfAccountId"
            style={{ maxWidth: "325px", height: "44px" }}
            className="ps-1"
            iconClassName="wa"
            icon={<Icon icon="arrow-down" />}
            textField="name"
            value={selectedBalanceSheetAccount}
            onChange={(e) => setSelectedBalanceSheetAccount(e.value)}
            placeholder="Select Balance Sheet Account"
            prefix={<InputPrefix>
                <PiBank size={15} color="#241CCA" className="ms-2" />
            </InputPrefix>}
        />
    );

    const profitAndLossComboBox = (
        <ComboBox
            data={profitAndLossAccounts}
            dataItemKey="chartOfAccountId"
            textField="name"
            value={selectedProfitAndLossAccount}
            onChange={(e) => setSelectedProfitAndLossAccount(e.value)}
            placeholder="Select Profit & Loss Account"
            style={{ maxWidth: "325px", height: "44px" }}
            className="ps-1"
            iconClassName="wa"
            icon={<Icon icon="arrow-down" />}
            prefix={<InputPrefix>
                <HiOutlineChartPie size={15} color="#241CCA" className="ms-2" />
            </InputPrefix>}
        />
    );

    return (
        <div className="container-fluid w-100 p-4 pt-2 mt-4 ">
            <div className="row h-100">
                <div className="col" style={{ maxWidth: "350px" }}>
                    <div
                        className={`p-4 pt-4 ${styles[`reportBackground`]} ${styles[`height`]}`}
                        style={{ height: "82vh" }}
                    >
                        <div className="mt-1">
                            {radioGroup}
                        </div>
                        <SectionDividerFull sectionName={""} />
                        <p className={`${styles[`heading`]}`} style={{ fontSize: "14.5px" }}>Chart of Accounts</p>
                        {(type === "" || type === "BalanceSheet") && (
                            <div className="d-flex flex-column mt-3">
                                <Label className="label mb-1">Balance Sheet</Label>
                                {balanceSheetComboBox}
                            </div>
                        )}
                        {(type === "" || type === "ProfitAndLoss") && (
                            <div className="d-flex flex-column mt-3">
                                <Label className="label mb-1">Profit & Loss</Label>
                                {profitAndLossComboBox}
                            </div>
                        )}
                        <SectionDividerFull sectionName={""} />
                        <div className="mt-2">
                            {dateRangeSection}
                        </div>
                        <SectionDividerFull sectionName={""} />
                        <div className={`${styles["checkbox-label"]} pt-3`}>{IncludeCheckbox}</div>
                        <div className={`${styles["checkbox-label"]} pt-1`}>{IncludeBudgetsCheckbox}</div>
                        {hasChartOfAccountSelected && (
                            <div className={`${styles["checkbox-label"]} pt-1`}>{ExcludeSundryCheckbox}</div>
                        )}
                        <div className="pt-4">{UpdateButton}</div>
                    </div>
                </div>

                <div className="col">
                    <div className={`row ${styles[`reportBackground`]} 1fr`}>
                        {reportViewer}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NominalBalances;
